import React, { Fragment } from "react";
import { Link } from "react-router-dom";
const CreateSaq = () => {
  return (
    <Fragment>
      <h2>Create a New SAQ</h2>
      <div className="card">
        <ul className="list-group list-group-flush">
          <p>
            If you are not sure which SAQ to take click the button below to use
            the saq wizard.
          </p>
          <div className="row">
            <div className="col-sm-2">
              <button className="btn btn-primary btn-sm">
                <Link to="create/wizard" style={{ color: "white" }}>
                  SAQ Wizard
                </Link>
              </button>
            </div>
          </div>
          <div style={{ height: "20px" }}></div>
        </ul>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <Link to="create/saq-a">SAQ A</Link>
          </li>
          <li className="list-group-item">
            <Link to="create/saq-a-ep">SAQ A-EP</Link>
          </li>
          <li className="list-group-item">
            <Link to="create/saq-b">SAQ B</Link>
          </li>
          <li className="list-group-item">
            <Link to="create/saq-b-ip">SAQ B-IP</Link>
          </li>
          <li className="list-group-item">
            <Link to="create/saq-c">SAQ C</Link>
          </li>
          <li className="list-group-item">
            <Link to="create/saq-d-me">SAQ D-ME</Link>
          </li>
          <li className="list-group-item">
            <Link to="create/saq-d-sp">SAQ D-SP</Link>
          </li>
        </ul>
      </div>
    </Fragment>
  );
};

export default CreateSaq;
